// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.KzIooeYDqkkARpyp2Ncu .G82udZhZ6ZgeA_nJEd6i{padding:12px 8px 12px 12px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `KzIooeYDqkkARpyp2Ncu`,
	"inputPadding": `G82udZhZ6ZgeA_nJEd6i`
};
export default ___CSS_LOADER_EXPORT___;
